import React from 'react';

const Testimonials = () => {
  return (
    <div>
      <h1>Testimonials</h1>
    </div>
  );
}

export default Testimonials;
